export type ScheduleFilterType = "GroupFilter" | "MemberFilter" | "ShiftFilter";
export const ScheduleFilterTypes = {
    GroupFilter: "GroupFilter" as ScheduleFilterType,
    ShiftFilter: "ShiftFilter" as ScheduleFilterType,
    MemberFilter: "MemberFilter" as ScheduleFilterType
};